/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {GetSettingsResponse, SettingsParams} from '../models/settings';
import {gqlQuery} from '../index';
import {type Settings} from '@adobe/exc-app/settings';

export const SETTINGS_QUERY = `
  query settingsQuery($appId: String!, $groupId: String!, $level: String!, $settings: JSON!) {
    getSettings(appId: $appId, groupId: $groupId, level: $level, settings: $settings) {
      settings
    }
  }
`;

export const getSettings = (options: SettingsParams): Promise<GetSettingsResponse> =>
  gqlQuery<GetSettingsResponse, Settings>(SETTINGS_QUERY, options);
